
const defaultState = {
    corpWebEnabled: false,
    // enableQto: false
};

export const toggleSettings = (state = defaultState) => {
    return state;
};
